import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

class PropertyValuationAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'property-valuation';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'property-valuations';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'created_at',
      'updated_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'date',
      'propertyUuid',
      'addressUuid',
      'generalEmv',
      'generalValuation',
      'regressionEmv',
      'regressionValuation',
      'comparisonEmv',
      'comparisonValuation',
      'defaultEmv',
      'defaultValuation',
      'heuristics',
      'distributions',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return [
    ];
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return [

    ];
  }

}

export default PropertyValuationAppResource;
